//数字转中文
export const toChinesNum = (num) => {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] // changeNum[0] = "零"
  const unit = ['', '十', '百', '千', '万']
  num = parseInt(num)
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse()
    let newNum = ''
    for (var i = 0; i < strArr.length; i++) {
      newNum = (i == 0 && strArr[i] == 0 ? '' : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? '' : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum
    }
    return newNum
  }
  const overWan = Math.floor(num / 10000)
  let noWan = num % 10000
  if (noWan.toString().length < 4) noWan = '0' + noWan
  return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
}

//base64转文件
export const base64toFile = (dataurl, filename = 'file')=>{
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  let file = new File([u8arr], `${filename}.${suffix}`, {
    type: mime
  })
  return file
}
//文件转base64
export const filetoBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

//url转base64
export const getImageBase64Data = (imgSrc)=>{
  function getBase64(img) {
    let canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    let dataURL = canvas.toDataURL('image/jpeg');
    return dataURL;
  }
  let baseUrl = new Promise(function (resolve, reject) {
    let image = new Image();
    image.crossOrigin = '*'; // 图片处理跨域
    if (imgSrc.indexOf('data:image/jpeg;base64') > -1) {
      image.src = imgSrc + '?v=' + Math.random(); // 处理图片从缓存获取
    } else {
      image.src = imgSrc;
    }
    image.onload = function () {
      let imageBase64Data = getBase64(image);
      resolve(imageBase64Data);
    }
  });
  return baseUrl;
}
//获取范围随机数，包括lower和upper
export const random = (lower, upper)=>{
	return Math.floor(Math.random() * (upper - lower + 1)) + lower;
}